import styled from 'styled-components';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import sharedStyles from '../styles';
import breakpoints from '../breakpoints';

const NavigateButton = styled(LocalizedLink)`
  background: ${({ theme }) => theme.colors.link};
  color: white;
  font-size: ${sharedStyles.fontSize.lg};
  font-weight: ${sharedStyles.fontWeight.bold};
  padding: ${sharedStyles.spacing['spacing-md']};
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.15s ease;
  display: inline-block;
  text-decoration: none;

  &:hover :not(:disabled) {
    background: ${({ theme }) => theme.colors.linkHover};
    color: white;
  }

  &.mobile {
    @media screen and (min-width: ${breakpoints.md}) {
      display: none;
    }
  }
`;

export default NavigateButton;
